<template>
  <div class="modal-dialog">

    <el-dialog :title="$t('home.informationFeedback')" :visible.sync="dialogFormVisible"
      :before-close="setDialogFormVisible">
      <el-card class="box-card" shadow="never">

        <div class="container-fuild Contact-container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item :label="$t('home.userName')" prop="name">
                  <el-input v-model="form.name" placeholder="Please Input" />
                </el-form-item>
                <el-form-item :label="$t('home.telephone')"  prop="telephone">
                  <el-input v-model="form.telephone" placeholder="Please Input" />
                </el-form-item>
                <el-form-item :label="$t('home.mailbox')"  prop="mailbox">
                  <el-input v-model="form.mailbox" placeholder="Please Input" />
                </el-form-item>
                <el-form-item :label="$t('home.content')"  >
                  <el-input type="textarea" v-model="form.content" :min-height="192"/>
                </el-form-item>
              </el-form>
            </div>
            <!--                    <div class="col-xs-12 col-sm-12 col-md-6">-->
            <!--                        <div id="map" class="wow zoomIn"></div>-->
            <!--                    </div>-->
          </div>
        </div>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="setDialogFormVisible(false)">{{ $t('home.close') }}</el-button>
        <el-button size="small" type="primary" @click="setDialogFormVisible(true)">{{ $t('home.subMit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/api/api";
import { Message } from "element-ui";
export default {
  name: 'EditDal',
  data() {

    return {
      form:{},
      // 表单校验
      rules: {
        name: [
          { required: true, message: "Please input", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "Please input", trigger: "blur" }
        ],
        mailbox: [
          { required: true, message: "Please input", trigger: "blur" }
        ],
      },
      value: '',
      dialogFormVisible: false,
      form1: {},
      form2: {},
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      },]
    };
  },
  created() {
    // console.log(this.$store.state.dialogFormVisible);
  },
  mounted() {

  },
  computed: {
    setVisible() {
      return this.$store.state.dialogFormVisible;
    }
  },
  watch: {
    setVisible: {
      handler(newVal) {
        console.log(newVal);
        this.dialogFormVisible = newVal;
      }
    }
  },
  methods: {
    setDialogFormVisible(val) {
      if (val) {
        this.$refs["form"].validate(valid => {
          if (valid) {
            api.submitCmsCustomer(this.form).then(res =>{
              Message({
                showClose: true,
                message: 'Submit Success',
                type: 'success'
              });
              this.form = {}
            })
          }
        });
      }
      this.$store.commit('setDialogFormVisible', false);
    }
  }
};
</script>
<style scoped>
.modal-dialog {
  position: fixed;
  margin: auto;
  z-index: 99999;
}

.modal-dialog>>>.el-dialog__body {
  padding: 0 !important;
}

.el-button--primary {
  background-color: #0d0d7ecb;
  border-color: #0d0d7ecb;
  /* border-radius: 2px; */
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>



// WEBPACK FOOTER //
// src/components/editDal.vue